/* unplugin-vue-components disabled */import { render } from "./IncertVoucher.vue?vue&type=template&id=f180a2f6&scoped=true&ts=true"
import script from "./IncertVoucher.vue?vue&type=script&lang=ts"
export * from "./IncertVoucher.vue?vue&type=script&lang=ts"

import "./IncertVoucher.vue?vue&type=style&index=0&id=f180a2f6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f180a2f6"]])

export default __exports__